import styled from '@emotion/styled';
import { DialogContent, DialogContentProps } from '@mui/material';
import { Variables } from '../variables';

export const DialogTitle = styled.p`
    margin: 0;
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: ${Variables.Colors.n100};
    white-space: pre-wrap;
`;

export const DialogTitleContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width:100%;
`;

export const DialogCloseButtonContainer = styled.p`
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: ${Variables.Colors.n100};
    white-space: pre-wrap;
    width: auto;
`;

export const ActionsContainer = styled.section`
    width: 100%;
    display: flex;
`;

export const StyledDialogContent = styled(DialogContent)`
    display: flex;
    overflow: hidden;
    min-width: 600px;
    /* Rewrite material style */
    padding: 0 !important;
` as React.ComponentType<DialogContentProps>;

export const OverflowedStyledDialogContent = styled(DialogContent)`
    display: flex;
    overflow: auto;
    min-width: 600px;
    /* Rewrite material style */
    padding: 0 !important;
` as React.ComponentType<DialogContentProps>;